(function(scope) {
  jQuery(document).ready(function($) {
    /**
     * FI
     */
    var $close = $(".lang-fi .message-container .close"),
      $parent = $(".lang-fi .message-container"),
      storage = new scope.CrisisMessageStorage("fi-crisis"),
      stored = storage.get("fi-crisis-banner");

    if (typeof stored == "undefined") {
      $parent.show();
    }

    $close.click(function(e) {
      e.preventDefault();
      $parent.hide();
      storage.set("fi-crisis-banner", "1");
    });

    /**
     * EN
     */
    var $enClose = $(".lang-en .message-container .close"),
      $enParent = $(".lang-en .message-container"),
      enStorage = new scope.CrisisMessageStorage("en-crisis"),
      enStored = enStorage.get("en-crisis-banner");

    if (typeof enStored == "undefined") {
      $enParent.show();
    }

    $enClose.click(function(e) {
      e.preventDefault();
      $enParent.hide();
      enStorage.set("en-crisis-banner", "1");
    });
  });
})(this);
